import { render } from "./Index.vue?vue&type=template&id=1431fba4&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=1431fba4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1431fba4"],['__file',"components/Admin/Matches/Edit/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1431fba4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1431fba4', __exports__)) {
    api.reload('1431fba4', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=1431fba4&scoped=true", () => {
    api.rerender('1431fba4', render)
  })

}


export default __exports__